import { render, staticRenderFns } from "./redPacketReceive.vue?vue&type=template&id=464327a2&"
import script from "./redPacketReceive.vue?vue&type=script&lang=js&"
export * from "./redPacketReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports